import { PartialsEvents } from 'assets/core/js/module/partialsManager'
import accommodationCards from 'assets/themes/campings/js/page/product/accommodationCards'

import type { PartialEventDetail } from 'assets/core/js/module/partialsManager'

export default (): void => {
  handleShowMoreAccommodations()
  handlePartialUpdate()
}

export function toggleAccommodations(target: string): void {
  const el = document.querySelector(`#${target}.results__list-wrapper`)

  if (!el) {
    return
  }

  const parentEl = el.parentElement
  const hiddenEls = parentEl?.querySelectorAll<HTMLElement>('.result__card-wrapper[data-visible]')

  hiddenEls?.forEach((el) => {
    if (el.getAttribute('data-visible') === 'true') {
      el.setAttribute('data-visible', 'false')
    } else {
      el.setAttribute('data-visible', 'true')
    }
  })

  const buttonEl = document.querySelector<HTMLButtonElement>(`button[data-additional-accommodations="${target}"]`)

  if (!buttonEl) {
    return
  }

  buttonEl.querySelectorAll('span').forEach((link) => {
    link.toggleAttribute('hidden')
  })
}

function handleShowMoreAccommodations(): void {
  const showAdditionalAccommodations = document.querySelectorAll<HTMLButtonElement>('.results__button-additional-accommodations')

  showAdditionalAccommodations.forEach((showAdditionalAccommodations) => {
    showAdditionalAccommodations.addEventListener('click', (e) => {
      const el = e.target as HTMLElement
      const target = el.getAttribute('data-additional-accommodations')

      target && toggleAccommodations(target)
    })
  })
}

function handlePartialUpdate(): void {
  const resultsEl = document.getElementById('results-list')

  if (!resultsEl) {
    return
  }

  const observer = new window.IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        accommodationCards()

        observer.unobserve(entry.target)
      }
    })
  })

  observer.observe(resultsEl)

  resultsEl.addEventListener(PartialsEvents.POST_UPDATE, (e) => {
    const event = e as CustomEvent<PartialEventDetail>

    if (event.detail.partial && event.detail.partial !== resultsEl) {
      return
    }

    // remove all sidepanels as they exists outside of the results element
    document.querySelectorAll('.accommodation__side-panel').forEach((el) => {
      el.remove()
    })
    handleShowMoreAccommodations()
  })
}
